<template>
  <section>
    <p class="font-size--18 font-weight-bold color--gray-100 mt-10 text-center">
      회원님의 아이디는 다음과 같습니다.
    </p>
    <v-layout class="mt-5" justify-center>
      <div class="result">
        <span class="font-size--18 font-weight-bold color--primary-100">{{ email }}</span>
      </div>
    </v-layout>
  </section>
</template>

<script>
export default {
  props: ['email'],
}
</script>

<style lang="scss" scoped>
p {
  word-break: keep-all;
}
.result {
  padding: 12px 20px;
  background-color: $primary-15;
  border-radius: 12px;
}
</style>
